"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isBoolean = _interopRequireDefault(require("../object/isBoolean"));

var _isNil = _interopRequireDefault(require("../object/isNil"));

var _creative = require("../../constants/creative");

var isAudible = function isAudible(content) {
  if ((0, _isNil["default"])(content)) return false;
  var audible = content.audible,
      contentType = content.contentType;
  return _creative.AUDIBLE_CONTENT_TYPES.has(contentType) && (0, _isBoolean["default"])(audible) && audible;
};

var _default = isAudible;
exports["default"] = _default;